import React, { useCallback } from 'react';
import { FVButton, FVLink } from '../fieldvision.style';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import Icon from '@mlb/react-patterns/v4/components/Icon/icon';
import useTracking from '@gameday/utils/hooks/useTracking';

export const ButtonTypes = {
    GAMEDAY: 'gameday',
    CAMERA: 'camera',
    FIELDVISION: 'fieldvision',
    TUTORIAL: 'tutorial',
    NATIVELOGIN: 'nativeLogin'
};

const Button = ({
    isLoggedIn,
    showPreview,
    showGameday,
    showFieldVision,
    showCameraMenu,
    fieldVisionOn,
    firstRunUser,
    showExplore,
    buttonType,
    buttonClickHandler
}) => {
    let buttonProps;
    const Tracking = useTracking();

    const onClickPreview = useCallback((e) => {
        Tracking.track.track_click({
            componentName: ['Gameday 3D Live'],
            text: '3d',
            activity: '3D Button Click'
        });

        if (showPreview) {
            showPreview();
        }
        if(buttonClickHandler) {
            buttonClickHandler();
        }
    }, [showPreview, buttonClickHandler]);

    const onClickNativeLogin = useCallback((e) => {
        Tracking.track.track_click({
            componentName: ['Gameday 3D Live'],
            text: '3d',
            activity: '3D Button Click'
        });

        if (showPreview) {
            showPreview()?.then(() => {
                if (firstRunUser && !fieldVisionOn) {
                    if (showExplore) {
                        showExplore(true);
                    }
                } else {
                    if (showFieldVision) {
                        showFieldVision();
                    }
                }
            }).catch((error) => {
                console.log('native login error', error);
            });
        }

    }, [showPreview, fieldVisionOn]);

    const onClickGameday = useCallback((e) => {
        Tracking.track.track_click({
            componentName: ['Gameday 3D Live'],
            text: '2D',
            activity: '2D Button Click'
        });

        if (showGameday) {
            showGameday();
        }
        if(buttonClickHandler) {
            buttonClickHandler();
        }
    }, [showGameday, buttonClickHandler]);

    const onClickExplore = useCallback((e) => {
        Tracking.track.track_click({
            componentName: ['Gameday 3D Live'],
            text: 'Tutorial',
            activity: 'Tutorial Button Click'
        });

        if (showExplore) {
            showExplore(true);
        }
        if(buttonClickHandler) {
            buttonClickHandler();
        }
    }, [showExplore, buttonClickHandler]);

    const onClickFieldVision = useCallback((e) => {
        Tracking.track.track_click({
            componentName: ['Gameday 3D Live'],
            text: '3D',
            activity: '3D Button Click'
        });
        if (showFieldVision) {
            showFieldVision();
        }
        if(buttonClickHandler) {
            buttonClickHandler();
        }
    }, [showFieldVision, buttonClickHandler]);

    const onClickCamera = useCallback((e) => {
        Tracking.track.track_click({
            componentName: ['Gameday 3D Live'],
            text: 'Camera options launch',
            activity: 'Camera Button Click'
        });
        if (showCameraMenu) {
            showCameraMenu();
        }
        if(buttonClickHandler) {
            buttonClickHandler();
        }
    }, [showCameraMenu, buttonClickHandler]);

    if (!isLoggedIn) {
        buttonProps = {
            handlers: {
                onClick: buttonType === ButtonTypes.NATIVELOGIN ? onClickNativeLogin : onClickPreview
            },
            text: '3D',
            iconProps: {
                name: 'gameday-3d',
                fill: '#',
                width: 24
            }
        };
    } else {
        if (firstRunUser && isLoggedIn && !fieldVisionOn) {
            buttonProps = {
                handlers: {
                    onClick: onClickExplore
                },
                text: '3D',
                iconProps: {
                    name: 'gameday-3d',
                    fill: '#',
                    width: 24
                }
            };
        } else if (fieldVisionOn) {
            if (buttonType === ButtonTypes.CAMERA) {
                buttonProps = {
                    handlers: {
                        onClick: onClickCamera
                    },
                    text: 'camera',
                    iconProps: {
                        name: 'camera-fv',
                        fill: '#',
                        width: 24
                    }
                };
            } else if (buttonType === ButtonTypes.TUTORIAL) {
                buttonProps = {
                    handlers: {
                        onClick: onClickExplore
                    },
                    text: 'tutorial',
                    iconProps: {
                        name: 'info-fv',
                        fill: '#',
                        width: 24
                    }
                };
            } else {
                buttonProps = {
                    handlers: {
                        onClick: onClickGameday
                    },
                    text: '2D',
                    iconProps: {
                        name: 'gameday-2d',
                        fill: '#',
                        width: 24
                    }
                };
            }
        } else {
            buttonProps = {
                handlers: {
                    onClick: onClickFieldVision
                },
                text: '3D',
                iconProps: {
                    name: 'gameday-3d',
                    fill: '#',
                    width: 24
                }
            };
        }
    }
    const { handlers, text, iconProps = null } = buttonProps;
    return (<FVButton $buttonType={buttonType} className={buttonType}><div><FVLink handlers={handlers} ariaLabel={ text }>{iconProps ? <Icon {...iconProps}/> : text}</FVLink></div></FVButton>);
};

Button.propTypes = {
    isLoggedIn: PropTypes.bool,
    showPreview: PropTypes.func,
    showGameday: PropTypes.func,
    showCameraMenu: PropTypes.func,
    showFieldVision: PropTypes.func,
    fieldVisionOn: PropTypes.bool,
    firstRunUser: PropTypes.bool,
    showExplore: PropTypes.func,
    buttonType: PropTypes.string
};

export default withTheme(Button);
